/**
 * @file Contributor dashboard UI — pages/Dashboard/Contributor/Home/components/DataEntryMethodSection.tsx.
 */

import React from "react";
import "./DataEntryMethodSection.css";

const DataEntryMethodSection: React.FC = () => {
  return (
    <section className="home-section">
      <h2 className="section-heading">Data entry method</h2>
      <p className="section-description">
        ICOMEC offers two flexible data entry methods, allowing contributors to choose what best suits their workflow.
      </p>
      <div className="method-cards-grid">
        {/* Option 1 */}
        <div className="method-card">
          <div className="method-card-icon">
            <img src="/images/data_entry_option1.PNG" alt="Enter data manually" />
          </div>
          <h3 className="method-card-title">Option 1: Enter data manually</h3>
          <p className="method-card-description">
            Enter values directly into the online forms
          </p>
        </div>

        {/* Option 2 */}
        <div className="method-card">
          <div className="method-card-icon">
            <img src="/images/data_entry_option2.PNG" alt="Import data using excel template" />
          </div>
          <h3 className="method-card-title">Option 2: Import data using excel template</h3>
          <ul className="method-card-list">
            <li>Download the pre-filled Excel template</li>
            <li>Populate required fields offline</li>
            <li>Upload the completed template to the platform.</li>
          </ul>
        </div>
      </div>
    </section>
  );
};

/** React component — Data Entry Method Section. */
export default DataEntryMethodSection;

